/**
 * Deterministic JSON-like string for cache keys (sorted object keys).
 */
export function stableStringify(obj) {
  if (obj === undefined) return '"undefined"';
  if (obj === null) return 'null';
  const t = typeof obj;
  if (t !== 'object') return JSON.stringify(obj);
  if (Array.isArray(obj)) {
    return `[${obj.map(stableStringify).join(',')}]`;
  }
  const keys = Object.keys(obj).sort();
  return `{${keys.map((k) => `${JSON.stringify(k)}:${stableStringify(obj[k])}`).join(',')}}`;
}
